<template>
    <div class="automation-action-settings">
        <journey-tree height="100%" @select="selectNode">
            <template #actions="{ node: childNode }">
                <span
                    class="icon"
                    v-if="!Object.values(childNode.children).length"
                >
                    <div
                        class="far fa"
                        :class="
                            selectedId === childNode.id
                                ? 'fa-check-square'
                                : 'fa-square-o'
                        "
                    ></div>
                </span>
            </template>
        </journey-tree>
    </div>
</template>
<style lang="scss">
.modal-action-move_client_stage {
    .node-parent {
        > .node-header {
            cursor: default;
            opacity: 0.4;
        }
    }
    .modal-dialog {
        max-width: 90vw;
        height: 90vh;
    }
    .modal-body {
        height: calc(100vh - 250px);
        max-height: calc(100vh - 250px);
        > div {
            height: 100%;
            > form {
                height: 100%;
                display: flex;
                flex-direction: column;
                .automation-action-settings {
                    flex-grow: 1;
                    overflow: auto;
                }
            }
        }
    }
}
</style>
<script>
import Tree from "../../../clients/journey/tree.vue";
export default {
    components: {
        "journey-tree": Tree,
    },
    props: {
        properties: Object,
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-move_client_stage-title"),
            description: this.t("automations-form-actions-move_client_stage-description"),
            selectedId: this.properties.selectedId || null,
        };
    },
    mounted: function () {
        this.$emit("mounted", this);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isValid() {
            return this.selectedId !== null;
        },
        selectNode(node) {
            if (Object.values(node.children).length === 0) {
                this.selectedId = node.id;
                this.changed();
            }
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                selectedId: this.selectedId,
            });
        },
    },
};
</script>
